import { useContext, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { Container, Grid } from "@mui/material";
import { LocaleContext } from "../../../routing/LangRouter";
import { resetState } from "../../../store/actions";
import { useTranslation } from "react-i18next";

//import constants
import { IS_MOBILE } from "../../../constants/breakpoints";

//import view components
import DesktopHeader from "./desktop-header";
import MobileHeader from "./mobile-header";

//import images and icons
import Icon from "../base-icon/icon";
import { ArrowDown2, Blogger, Book1, Call, Category2, Element4, Judge, Note } from "iconsax-react";

function Header({ dispatch }) {
    //general variables
    const location = useLocation();
    const { t } = useTranslation();
    const { locale } = useContext(LocaleContext);

    //menu list
    const menuList = [
        {
            id: 1,
            value: "services",
            label: `${t("services")}`,
            icon: IS_MOBILE ? <Category2 size="20" /> : <ArrowDown2 size="20" color="var(--teal-color-18)" />,
            subMenu: [
                { id: 1, value: "itinerary", label: `${t("itinerary")}`, to: `/${locale}/itinerary` },
                {
                    id: 2,
                    value: "flight",
                    label: `${t("domesticFlight")}`,
                    to: `/${locale}/flight-search/domestic`,
                    generalInformation: { isTicket: true, isAccommodation: false, isItinerary: false, isFlightInternational: false },
                },
                {
                    id: 3,
                    value: "intFlight",
                    label: `${t("internationalFlight")}`,
                    to: `/${locale}/flight-search/international`,
                    generalInformation: { isTicket: true, isAccommodation: false, isItinerary: false, isFlightInternational: true },
                },
                {
                    id: 4,
                    value: "hotel",
                    label: `${t("domesticHotel")}`,
                    to: `/${locale}/hotel-search/domestic`,
                    generalInformation: { isTicket: false, isAccommodation: true, isItinerary: false, isHotelInternational: false },
                },
                {
                    id: 5,
                    value: "hotel",
                    label: `${t("internationalHotel")}`,
                    to: `/${locale}/hotel-search/international`,
                    generalInformation: { isTicket: false, isAccommodation: true, isItinerary: false, isHotelInternational: true },
                },
                { id: 6, value: "tour", label: `${t("tour")}`, to: `/${locale}/tour` },
                { id: 7, value: "specialTours", label: `${t("specialTours")}`, to: `/fr/country-tour` },
                { id: 8, value: "medicalTourism", label: `${t("medicalTourism")}`, to: `/${locale}/medical-tourism` },
                {
                    id: 9,
                    value: "studyAbroad",
                    label: `${t("Study Abroad.Study Abroad")}`,
                    to: `/${locale}/study-abroad`,
                    icon: IS_MOBILE && <Book1 size="20" />,
                },
                {
                    id: 10,
                    value: "studyAbroad",
                    label: `${t("General.Work Immigration")}`,
                    to: `/${locale}/work-immigration`,
                    icon: IS_MOBILE && <Book1 size="20" />,
                },
            ],
        },
        { id: 2, value: "rules", label: `${t("policies")}`, to: `/${locale}/rules`, icon: IS_MOBILE && <Note size="20" /> },
        {
            id: 3,
            value: "submitComplaints",
            label: `${t("submitComplaints")}`,
            to: `/${locale}/submit-complaints`,
            icon: IS_MOBILE && <Judge size="24" />,
        },
        {
            id: 4,
            value: "aboutUs",
            label: `${t("aboutUs")}`,
            to: `/${locale}/about-us`,
            icon: IS_MOBILE && <Icon name="AtripaIcon" width="1.5rem" height="1.625rem" />,
        },
        { id: 5, value: "contactUs", label: `${t("contactUs")}`, to: `/${locale}/contact-us`, icon: IS_MOBILE && <Call size="20" /> },
        { id: 6, value: "blog", label: `${t("General.blog")}`, to: `/blog/${locale}`, icon: IS_MOBILE && <Blogger size="20" /> },
    ];

    //handle click items
    const handleMenuClick = useCallback(
        (event, item) => {
            sessionStorage.clear();
            if (location.pathname === item.to) {
                event.preventDefault();
                event.stopPropagation();
            } else {
                if (item.value === "flight" || item.value === "hotel") {
                    sessionStorage.setItem("generalInformation", JSON.stringify(item?.generalInformation));
                }

                dispatch(resetState());
            }
        },
        [location.pathname, dispatch],
    );

    const AUTHORIZED_ROUTES = [
        "/{locale}",
        "/{locale}/contact-us",
        "/{locale}/about-us",
        "/{locale}/rules",
        "/{locale}/submit-complaints",
        "/{locale}/flight-search/domestic",
        "/{locale}/flight-search/international",
        "/{locale}/hotel-search/domestic",
        "/{locale}/hotel-search/international",
        "/{locale}/login",
        "/{locale}/itinerary",
        "/{locale}/study-abroad",
        "/{locale}/country-tour",
        "/{locale}/country-tour-detail",
    ];
    // Check if the current route is in the list of authorized routes
    const isAuthorizedRoute = AUTHORIZED_ROUTES.includes(location.pathname.replace(locale, "{locale}"));

    return (
        <Grid className={`header ${isAuthorizedRoute && "is-authorized-route"}`} component="header" container item xs={12} alignItems="center">
            <Container maxWidth="xl">
                {IS_MOBILE ? (
                    isAuthorizedRoute && <MobileHeader menuList={menuList} handleMenuClick={handleMenuClick} />
                ) : (
                    <DesktopHeader menuList={menuList} handleMenuClick={handleMenuClick} />
                )}
            </Container>
        </Grid>
    );
}

export default connect()(Header);
